import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptor } from "src/utils/baseQuery";
import { TransporterDriverInterface } from "src/services/transporterDrivers/transporterDriverSlice";

interface UpdateTransporterDriver {
    id: string;
    data: Partial<TransporterDriverInterface>;
}
export const TransportDriverApi = createApi({
    reducerPath: "TransporterDriverApi",
    baseQuery: baseQueryWithInterceptor,
    tagTypes: ["TransporterDriver"],
    endpoints: (builder) => ({
        // getTransporterDriverById: builder.query<TransporterDriverInterface, string>({
        //   query: (id) => ({
        //     headers: {
        //       "Content-type": "application/json",
        //     },
        //     url: `organization/${id}`,
        //     method: "GET",
        //   }),
        // }),
        getDriverById: builder.query<any, string>({
            query: (id) => ({
                headers: {
                    "Content-type": "application/json",
                },
                url: `company/${id}`,
                method: "GET",
            }),
        }),
        getActiveEmployeeList: builder.query<any, void>({
            query: (companyId) => ({
                headers: {
                    "Content-type": "application/json",
                },
                // url: `user/driver?driver=&company=${companyId}`,
                url: `user/search-employee?company=${companyId}`,
                method: "GET",
            }),
        }),
        getAllEmployeeList: builder.query<any, any>({
            query: ({companyId, search }) => ({

                headers: {
                    "Content-type": "application/json",
                },
                url: `user?type=employee&company=${companyId}&name=${search}`,
                method: "GET",
            }),
        }),
        getDriverList: builder.query<any, void>({
            query: (companyId) => ({
                headers: {
                    "Content-type": "application/json",
                },
                // url: `user/driver?driver=&company=${companyId}`,
                url: `user?type=driver&company=${companyId}`,
                method: "GET",
            }),
        }),
        getEscortList: builder.query<any, void>({
            query: (companyId) => ({
                headers: {
                    "Content-type": "application/json",
                },
                // url: `user/driver?driver=&company=${companyId}`,
                url: `user?type=escort&company=${companyId}`,
                method: "GET",
            }),
        }),
        addUser: builder.mutation<any, any>({
            query: (formData) => ({
                headers: {
                    // Do NOT set Content-Type here, let fetch handle the boundary automatically
                },
                url: `user`,
                method: "POST",
                body: formData,
            }),
        }),
        updateUser: builder.mutation<any, any>({
            query: ({data, id}) => ({
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                url: `user/${id}`,
                method: "PATCH",
                body: data,
            }),

        }),
        searchDriverByName: builder.query<any, any>({
            query: ({companyId, search }) => ({

                headers: {
                    "Content-type": "application/json",
                },
                url: `user/driver?company=${companyId}&driver=${search}`,
                method: "GET",
            }),
        }),
        searchEscortByName: builder.query<any, any>({
            query: ({companyId, search }) => ({

                headers: {
                    "Content-type": "application/json",
                },
                url: `user/escort?company=${companyId}&escort=${search}`,
                method: "GET",
            }),
        }),
        searchEmployeeByName: builder.query<any, any>({
            query: ({companyId, search }) => ({

                headers: {
                    "Content-type": "application/json",
                },
                url: `user?type=employee&company=${companyId}&name=${search}`,
                method: "GET",
            }),
        }),
        patchCompanyById: builder.mutation<any, any>({
            query: ({ id, data }) => ({
                headers: {
                    "Content-type": "application/json",
                },
                url: `company/${id}`,
                method: "PATCH",
                body: data,
            }),
        }),
        patchTransporterDriverById: builder.mutation<
            TransporterDriverInterface,
            UpdateTransporterDriver
        >({
            query: ({ id, data }) => ({
                headers: {
                    "Content-type": "application/json",
                },
                url: `organization/${id}`,
                method: "PATCH",
                body: data,
            }),
        }),
    }),
});

export const {
    useGetDriverByIdQuery,
    useGetDriverListQuery,
    useGetActiveEmployeeListQuery,
    useGetAllEmployeeListQuery,
    useGetEscortListQuery,
    useSearchDriverByNameQuery,
    useSearchEscortByNameQuery,
    useSearchEmployeeByNameQuery,
    usePatchCompanyByIdMutation,
    usePatchTransporterDriverByIdMutation,
    useAddUserMutation,
    useUpdateUserMutation
} = TransportDriverApi;
